import { useEffect, useState } from 'react';
import { Button, Modal } from '../components/ui';
import '../components/ui/common.css';
import { settingsAPI } from '../services/api';

const Settings = () => {
    const [workoutTypes, setWorkoutTypes] = useState([]);
    const [habitTypes, setHabitTypes] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(''); // 'workout' or 'habit'
    const [newTypeName, setNewTypeName] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadTypes();
    }, []);

    const loadTypes = async () => {
        try {
            const [workoutRes, habitRes] = await Promise.all([
                settingsAPI.getWorkoutTypes(),
                settingsAPI.getBadHabitTypes()
            ]);
            setWorkoutTypes(workoutRes.data);
            setHabitTypes(habitRes.data);
        } catch (error) {
            console.error('Error loading types:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddType = async (e) => {
        e.preventDefault();
        try {
            if (modalType === 'workout') {
                await settingsAPI.createWorkoutType({ name: newTypeName });
            } else {
                await settingsAPI.createBadHabitType({ name: newTypeName });
            }
            setModalOpen(false);
            setNewTypeName('');
            loadTypes();
        } catch (error) {
            console.error('Error adding type:', error);
            alert(error.response?.data?.error || 'Ошибка при добавлении');
        }
    };

    const handleDeleteType = async (id, type) => {
        if (!window.confirm('Удалить этот тип?')) return;
        try {
            if (type === 'workout') {
                await settingsAPI.deleteWorkoutType(id);
            } else {
                await settingsAPI.deleteBadHabitType(id);
            }
            loadTypes();
        } catch (error) {
            console.error('Error deleting type:', error);
            alert(error.response?.data?.error || 'Ошибка при удалении');
        }
    };

    const openAddModal = (type) => {
        setModalType(type);
        setNewTypeName('');
        setModalOpen(true);
    };

    if (loading) {
        return <div className="loading">Загрузка...</div>;
    }

    return (
        <div>
            <h1>Настройки</h1>

            <div style={{ marginBottom: 'var(--spacing-xl)' }}>
                <div className="page-header" style={{ marginBottom: 'var(--spacing-md)' }}>
                    <h2>Типы тренировок</h2>
                    <Button size="sm" onClick={() => openAddModal('workout')}>+ Добавить</Button>
                </div>

                <div className="card">
                    {workoutTypes.length === 0 ? (
                        <p style={{ color: 'var(--text-secondary)' }}>Нет типов</p>
                    ) : (
                        <div>
                            {workoutTypes.map((type) => (
                                <div
                                    key={type.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: 'var(--spacing-md)',
                                        borderBottom: '1px solid var(--border-color)'
                                    }}
                                >
                                    <div>
                                        <span style={{ fontWeight: '500' }}>{type.name}</span>
                                        {type.isDefault && (
                                            <span style={{
                                                marginLeft: 'var(--spacing-sm)',
                                                fontSize: '0.75rem',
                                                padding: '0.25rem 0.5rem',
                                                backgroundColor: 'var(--bg-secondary)',
                                                borderRadius: 'var(--radius-sm)',
                                                color: 'var(--text-secondary)'
                                            }}>
                                                По умолчанию
                                            </span>
                                        )}
                                    </div>
                                    {!type.isDefault && (
                                        <button
                                            className="icon-btn"
                                            onClick={() => handleDeleteType(type.id, 'workout')}
                                        >
                                            🗑️
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div>
                <div className="page-header" style={{ marginBottom: 'var(--spacing-md)' }}>
                    <h2>Типы негативных привычек</h2>
                    <Button size="sm" onClick={() => openAddModal('habit')}>+ Добавить</Button>
                </div>

                <div className="card">
                    {habitTypes.length === 0 ? (
                        <p style={{ color: 'var(--text-secondary)' }}>Нет типов</p>
                    ) : (
                        <div>
                            {habitTypes.map((type) => (
                                <div
                                    key={type.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: 'var(--spacing-md)',
                                        borderBottom: '1px solid var(--border-color)'
                                    }}
                                >
                                    <div>
                                        <span style={{ fontWeight: '500' }}>{type.name}</span>
                                        {type.isDefault && (
                                            <span style={{
                                                marginLeft: 'var(--spacing-sm)',
                                                fontSize: '0.75rem',
                                                padding: '0.25rem 0.5rem',
                                                backgroundColor: 'var(--bg-secondary)',
                                                borderRadius: 'var(--radius-sm)',
                                                color: 'var(--text-secondary)'
                                            }}>
                                                По умолчанию
                                            </span>
                                        )}
                                    </div>
                                    {!type.isDefault && (
                                        <button
                                            className="icon-btn"
                                            onClick={() => handleDeleteType(type.id, 'habit')}
                                        >
                                            🗑️
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <Modal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title={`Добавить тип ${modalType === 'workout' ? 'тренировки' : 'привычки'}`}
                footer={
                    <>
                        <Button variant="secondary" onClick={() => setModalOpen(false)}>Отмена</Button>
                        <Button onClick={handleAddType}>Добавить</Button>
                    </>
                }
            >
                <form onSubmit={handleAddType}>
                    <div className="form-group">
                        <label htmlFor="typeName">Название</label>
                        <input
                            id="typeName"
                            type="text"
                            value={newTypeName}
                            onChange={(e) => setNewTypeName(e.target.value)}
                            required
                            placeholder="Введите название"
                            autoFocus
                        />
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default Settings;
